import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  GECKO_CONSTS,
  GeckoModalService,
  GeckoModal,
  GeckoCardTable,
  GeckoToastService,
} from 'ui';
import GeckoPagination from 'services/gecko-pagination';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import GeckoDate from 'services/gecko-date';
import { renderError } from 'services/gecko-error';

class Workflows extends Component {
  tableColumns = [
    {
      key: 'name',
      name: 'Name',
      render: (name, item) => (item.draft ? item.draft._step1value : name),
      width: '50%',
      sortable: true,
    },
    {
      key: 'createdAt',
      name: 'Created',
      render: (val) => new GeckoDate(val).LONG_TIME,
      width: '50%',
      sortable: true,
    },
    {
      key: '_',
      name: 'Status',
      type: GECKO_CONSTS.TABLE_CELL_TYPE_STATUS,
      tooltip: false,
      styles: [
        {
          name: 'Live',
          type: GECKO_CONSTS.STATUS_TYPE_SUCCESS,
          key: 'active',
        },
        {
          name: 'Draft',
          type: GECKO_CONSTS.STATUS_TYPE_DEFAULT,
          key: 'draft',
        },
        {
          name: 'Paused',
          type: GECKO_CONSTS.STATUS_TYPE_WARNING,
          key: 'paused',
        },
      ],
      render: (_, workflow) => {
        if (workflow.draft) {
          return 'draft';
        }
        if (workflow.active) {
          return 'active';
        }
        return 'paused';
      },
    },
    {
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
      items: [
        {
          name: 'Pause',
          handler: (workflow) => {
            return GeckoRequest.post(`/workflow/${workflow.id}/pause`)
              .then(() =>
                new GeckoToastService().success(
                  `${workflow.name} has been paused`
                )
              )
              .catch(renderError);
          },
          hideWhen: (workflow) => workflow.active === false,
        },
        {
          name: 'Resume',
          handler: (workflow) => {
            return GeckoRequest.post(`/workflow/${workflow.id}/set-live`)
              .then(() =>
                new GeckoToastService().success(
                  `${workflow.name} has been resumed`
                )
              )
              .catch(renderError);
          },
          hideWhen: (workflow) => workflow.active === true,
        },
        {
          name: 'Edit',
          handler: this.openWorkflow,
        },
        {
          name: 'Remove',
          handler: (workflow) => this.openDeleteConfirmationModal(workflow),
        },
      ],
    },
  ];

  openDeleteConfirmationModal(workflow) {
    new GeckoModalService().open(() => {
      return (
        <GeckoModal
          name="Delete Workflow"
          children={<p>Are you sure you wish to delete this workflow?</p>}
          btns={[
            {
              name: 'Cancel',
              secondary: true,
              icon: 'fa fa-times',
              handler: () => {
                return new GeckoModalService().close();
              },
            },
            {
              type: GECKO_CONSTS.BTN_TYPE_DANGER,
              name: 'Confirm Delete',
              icon: 'fa fa-trash-alt',
              handler: () => {
                const url = workflow.draft
                  ? `/workflow/draft/${workflow.id}`
                  : `/workflow/${workflow.id}`;
                GeckoRequest.delete(url)
                  .then(() => {
                    new GeckoModalService().close();
                    if (workflow.draft) {
                      new GeckoToastService().success(
                        `${workflow.draft._step1value} has been removed.`
                      );
                    } else {
                      new GeckoToastService().success(
                        `${workflow.name} has been removed.`
                      );
                    }
                  })
                  .catch(renderError);
              },
            },
          ]}
        />
      );
    });
  }

  headerButtons = [
    {
      preset: GECKO_CONSTS.BTN_PRESET_ADD,
      name: 'New Workflow',
      handler: () => {
        return GeckoLocation.goTo('/automation/workflows/new');
      },
    },
  ];

  openWorkflow(workflow) {
    return GeckoLocation.goTo('/automation/workflows/' + workflow.id);
  }

  render() {
    const searchedWorkflows = this.props.params.search
      ? this.props.workflows.filter((workflow) => {
          return (
            (workflow.draft
              ? workflow?.draft?._step1value ?? ''
              : workflow.name
            )
              .toUpperCase()
              .indexOf(this.props.params.search.toUpperCase()) !== -1
          );
        })
      : this.props.workflows;

    const [workflows, pagination] = GeckoPagination.paginate({
      page: this.props.params.page,
      order_by: this.props.params.order_by,
      sort: this.props.params.sort,
    })(searchedWorkflows);

    const alertDetails = this.props.workflows?.length
      ? { alert: 'There are no results to show.' }
      : {
          alert: 'You have not created any Workflows yet.',
          link: '#/automation/workflows/new',
        };

    return (
      <div className="content-margin">
        <GeckoCardTable
          name="Workflows"
          headerBtns={this.headerButtons}
          rows={workflows}
          cols={this.tableColumns}
          rowHandler={this.openWorkflow}
          pagination={pagination}
          onSearch={(term) =>
            GeckoLocation.goTo(
              '/automation/workflows',
              Object.assign({}, this.props.params, { search: term })
            )
          }
          link={alertDetails.link}
          alert={alertDetails.alert}
          headerProps={{ searchPlaceholder: 'Search workflows' }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workflows: state.workflows,
    params: state.location.params,
  };
};

export default connect(mapStateToProps)(Workflows);
